import { SectionView } from './SectionView';
import { XrayPanelContextProvider } from '../context/XrayPanelContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewContainer = ({
  auditResults,
  config,
  artifacts,
  contentId,
  auth,
  tracker,
  withReadabilitySection = false
}) => {
  return /*#__PURE__*/_jsx(XrayPanelContextProvider, {
    auth: auth,
    tracker: tracker,
    children: /*#__PURE__*/_jsx(SectionView, {
      auditResults: auditResults,
      config: config,
      artifacts: artifacts,
      contentId: contentId,
      withReadabilitySection: withReadabilitySection
    })
  });
};